import { render, staticRenderFns } from "./tuantuan.vue?vue&type=template&id=6de7f9ce"
import script from "./tuantuan.vue?vue&type=script&lang=js"
export * from "./tuantuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports